// extracted by mini-css-extract-plugin
export var active = "Navbar-module--active--Zh6Sc";
export var container = "Navbar-module--container--8VJuI";
export var expanded = "Navbar-module--expanded--Mw+4p";
export var hasSubmenu = "Navbar-module--hasSubmenu--AVjtm";
export var item = "Navbar-module--item--VeNU2";
export var logo = "Navbar-module--logo--moYhX";
export var menu = "Navbar-module--menu--ccnM9";
export var menuToggle = "Navbar-module--menuToggle--8KvE4";
export var menuWrapper = "Navbar-module--menuWrapper--b8RC4";
export var root = "Navbar-module--root--Wxoiu";
export var scrolled = "Navbar-module--scrolled--9cURU";
export var searchBar = "Navbar-module--searchBar--5zWwg";
export var spacer = "Navbar-module--spacer--PDs21";
export var subitem = "Navbar-module--subitem--6Yu-Q";
export var submenu = "Navbar-module--submenu--LDUQn";